import { createSlice, current } from "@reduxjs/toolkit";
import { initialState } from "./initialState";
import { addSelectedClaimToERAManually, eraProcedureDataSave, getAdjustmentCode, getClaimDetailsOnSelect, getClaimListForDropDown, getClaimStatusSubStatus, getERAlist, getERApayerList, getERASummuryData, MarkAsReviewed, MarkAsReviewedOnSave, onAllERAListExport, onApplyPayment, onDeleteClaimAction, onExportFiles, reviewClaimData, SaveEraDetails } from "./AsyncThunkAPI";
import { PAGING_END_INDEX } from "../../../../utilities/staticConfigs";
import { checkForError, checkFoValueChange, enableMovedToCredit, eraDataFormatter, headerResultFormatter, structureProcedureData, summaryResultFromatter } from "./DataProcessor";
import { RESPONSIBILITY_TYPES } from "../../../../utilities/dictionaryConstants";
import i18n from "../../../../utilities/i18n";
import { YMD_TO_MDY } from "../../../../utilities/commonUtilities";
import { decimalConverter } from "../../PaymentModule/StateManagement/paymentDataProcessor";
import { columnsNameList1, columnsNameList2, columnsNameList3, columnsNameList4, columnsNameList5, defaultSelectedColumnsList, filter_Options } from "../constants";
import { DateTime } from "luxon";
import { DELETE_SUCCESS } from "../../../../utilities/labelConfigs";
import fileDownload from "js-file-download";
const eraSlice = createSlice({
    name: 'eraslice',
    initialState,
    reducers: {
        /**
         * on search value field changes value stored through this function
         * @param {*} state 
         * @param {*} actions 
         */
        onHandleChangeVariables: (state, actions) => {
            let { name, value, names } = actions.payload;
            if (value && value.length > 0 && names) {
                let name = names;
                let val = value[0].id;
                state.eraSearchVariables[name] = val;
                if (name === 'payer' && value.length > 0) {
                    state.eraSearchVariables.searchPayer = value;
                }

            } else if (value.length === 0 && names == 'payer') {  // To clear the current selection from Search ERA AsyncTypeInput
                state.eraSearchVariables.searchPayer = ([]);
                state.eraSearchVariables[names] = "";
            } else {
                let val = value;
                if (name && name === "payment_amount") {
                    val = String(value).trim().replace(/[^0-9.]/g, '');
                }

                state.eraSearchVariables[name] = val;
            }
        },

        /**
         * era date value change store through this function
         * @param {*} state 
         * @param {*} actions 
         */
        onHandleDateChange: (state, actions) => {
            let { value, name } = actions.payload;
            state.eraSearchVariables[name] = value
        },

        /**
         * on pagination previous page click action triggered here
         * @param {*} state 
         * @param {*} action 
         */
        onPagePreviousChange: (state) => {
            const previousPage = state.pagination.startIndex - PAGING_END_INDEX + 1;
            state.pagination.activePage = previousPage;
            if (state.pagination.startIndex !== 0) {
                state.pagination.startIndex = (state.pagination.startIndex - PAGING_END_INDEX);
                state.pagination.endIndex = (state.pagination.endIndex - PAGING_END_INDEX);
            }

            state.calledFrom = "onPagePrevious";
        },

        /**
         * 
         * @param {*} state 
         * @param {*} action 
         */
        onGridCheckBoxClickEraList: (state, action) => {
            const { selected, id, clickedFrom } = action.payload;

            if (clickedFrom === "data") {
                const index = state.selectedEraList.indexOf(id);
                if (index >= 0) {
                    state.selectedEraList.splice(index, 1);
                } else {
                    state.selectedEraList.push(id);
                }

                // Update checkbox for the clicked row
                state.eraTableData = state.eraTableData.map(item =>
                    item.id === id ? { ...item, checkbox: selected } : item
                );

                state.selectAll = state.selectedEraList.length === state.eraTableData.length;

            } else if (clickedFrom === "header") {
                const allIds = selected ? state.eraTableData.map(item => item.id) : [];
                state.eraTableData = state.eraTableData.map(item => ({
                    ...item,
                    checkbox: selected
                }));

                state.selectedEraList = allIds;
                state.selectAll = selected;
            }
        },
        /**
         * next page number called and action triggered here
         * @param {*} state 
         */
        onPageNextChange: (state) => {
            const nextPage = state.pagination.startIndex + PAGING_END_INDEX + 1;
            const canIncrementIndexes = state.pagination.endIndex === state.pagination.totalPage || state.pagination.totalPage <= PAGING_END_INDEX;
            state.pagination.activePage = nextPage;
            state.pagination.startIndex = (canIncrementIndexes ? state.pagination.startIndex : state.pagination.startIndex + PAGING_END_INDEX);
            state.pagination.endIndex = (canIncrementIndexes ? state.pagination.endIndex : state.pagination.endIndex + PAGING_END_INDEX);
            state.calledFrom = "onPageNext";
        },

        /**
         * on page up function call triggered here
         * @param {*} state 
         */
        onPageUpChange: (state, action) => {
            const page = Number(action.payload);
            state.pagination.activePage = page;
            state.calledFrom = "onPageUp";
        },

        /**
         * page limit select on change function triggered here
         * @param {*} state 
         * @param {*} action 
         */
        onPageLimitChange: (state, action) => {
            let pageLimit = Number(action.payload)
            state.pageSelector.pageLimit = pageLimit;
            state.activePage = 1;
            state.calledFrom = "PageLimit";
        },

        /**
         * reducer function to show notification
         * @param {*} state 
         * @param {*} actions 
         */
        showNotifyWindow: (state, actions) => {
            state.notifyMessage = actions.payload.message;
            state.showNotification = true;
            state.statusTag = actions.payload.status
        },

        /**
         * function to reset notification data
         * @param {*} state 
         */
        resetNotifyWindow: (state) => {
            state.notifyMessage = "";
            state.statusTag = "";
            state.showNotification = false
        },

        /**
         * function  to reset era search fiel values
         * @param {*} state 
         */
        onResetERASearchVariable: (state) => {
            state.eraSearchVariables = initialState.eraSearchVariables;
        },

        /**
         * function to listen procedure value change
         * @param {*} state 
         * @param {*} actions 
         */
        onHandleApply: (state, actions) => {
            //eslint-disable-next-line
            let { value, id, name } = actions.payload;

            let { procedureData } = current(state);
            // Convert to two decimal points when the input has more than 2 decimal points
            if (!isNaN(Number(value))) {
                let parts = String(value).split('.');
                if (parts.length > 1 && parts[1].length > 2) {
                    value = parseFloat(value)?.toFixed(2);
                }
            }

            if (name === 'responsibility_type' || name === 'claim_status_id' || name === 'claim_sub_status_id' || name === 'paid_by_entity')
                value = parseInt(value);
            state.procedureData[id][name] = value ? value : "";

            if (name == "paid_by_entity") {
                let { paid_by_entity, is_primary_paid, is_secondary_paid, is_tertiary_paid } = state.procedureData[id];
                let enable_moved_to_credit = enableMovedToCredit(paid_by_entity, is_primary_paid, is_secondary_paid, is_tertiary_paid)
                state.procedureData[id] = {
                    ...state.procedureData[id],
                    enable_moved_to_credit: enable_moved_to_credit,
                    moved_to_credit:state.duplicateProcedureData[id]?.moved_to_credit
                };

                if(!enable_moved_to_credit){
                    state.procedureData[id] = {
                        ...state.procedureData[id],
                        moved_to_credit:false
                    };
                }
            }

            //Conditionally clearing the states
            if (name === 'responsibility_type') {
                state.procedureData[id]["claim_status_id"] = null;
                state.procedureData[id]["claim_sub_status_id"] = null;
            } else if (name === 'claim_status_id') {
                state.procedureData[id]["claim_sub_status_id"] = null;
            }

            if (isNaN(state.procedureData[id]['charges'] - state.procedureData[id]['allowed_amount'])) {
                state.procedureData[id] = procedureData[id];
            }
            else {
                if (name === 'allowed_amount') {
                    state.procedureData[id]['adjustment_amount1'] = state.procedureData[id]['charges'] - state.procedureData[id]['allowed_amount'];
                }
            }
        },

        /**
         * function to change values accordingly on field blurer function
         * here it will change value like responsibility
         * @param {} state 
         * @param {*} actions 
         */
        onBlurApplyValue: (state, actions) => {
            let { name, id, adjustmentId } = actions.payload;
            const { procedureData, procedureError, resposibility, list, duplicateProcedureData } = current(state);
            const { claimStatusList } = list;
            let { claim_status_id, claim_sub_status_id, responbility_id, closingBalance, denial, res_status } = checkFoValueChange(id, procedureData, resposibility, claimStatusList);
            state.procedureData[id]["closing_balance"] = closingBalance;
            state.procedureData[id]["responsibility_type"] = responbility_id ?? duplicateProcedureData[id]["responsibility"];
            if (responbility_id === duplicateProcedureData[id].responsibility_type) {
                if (denial == true) {
                    state.procedureData[id]["claim_status_id"] = claim_status_id ? claim_status_id : null;
                    state.procedureData[id]["claim_sub_status_id"] = claim_sub_status_id ? claim_sub_status_id : null;
                    return
                } else if (name == "adjustment_code2_data" && !res_status) {
                    state.procedureData[id]["claim_status_id"] = null;
                    state.procedureData[id]["claim_sub_status_id"] = null
                } else {
                    state.procedureData[id]["claim_status_id"] = duplicateProcedureData[id].claim_status_id ?? null;
                    state.procedureData[id]["claim_sub_status_id"] = duplicateProcedureData[id].claim_sub_status_id ?? null
                }
            }
            else {
                if (denial == true) {
                    state.procedureData[id]["claim_status_id"] = claim_status_id ? claim_status_id : null;
                    state.procedureData[id]["claim_sub_status_id"] = claim_sub_status_id ? claim_sub_status_id : null;
                } else {
                    state.procedureData[id]["claim_status_id"] = null;
                    state.procedureData[id]["claim_sub_status_id"] = null;
                }
            }
            const error = checkForError(name, id, adjustmentId, procedureData, procedureError);
            state.procedureError[id] = error;
        },

        handleAdjustmentCodeChangeAction: (state, actions) => {
            let { e, id, type } = actions.payload;
            const { procedureData } = current(state);
            // Validate if the requesting adjustment code already there in the entry
            const procedureCodes = [...procedureData[id]['adjustment_code1_data'], ...procedureData[id]['adjustment_code2_data']];
            if (procedureCodes.some((item) => item.id === e[0].id)) {
                state.showNotification = true;
                state.notifyMessage = i18n.t("errorMessages.duplicate_entry");
                state.statusTag = "error";
                return
            } if (
                (e[0].label === 'PR-1' || e[0].label === 'PR-2' || e[0].label === 'PR-3')
                && type !== 'adjustment_code2_data'
            ) {
                state.showNotification = true;
                state.notifyMessage = i18n.t("errorMessages.PR_added");
                state.statusTag = "error";
                return
            }

            state.procedureData[id][type] = [...state.procedureData[id][type], { ...e[0], amount: 0 }]
        },

        /**
        * redux function to remove adjustment codes
        * @param {*} state 
        * @param {*} actions 
        */
        removeAdjustmentCode: (state, actions) => {
            let { item, id, index, adjustment } = actions.payload;
            const newEraAdjustments1 = [...state.procedureData[id][adjustment]];
            newEraAdjustments1.splice(index, 1);
            state.procedureData[id][adjustment] = newEraAdjustments1;
            if (
                (item.label === 'PR-1' || item.label === 'PR-2' || item.label === 'PR-3')
            ) {
                switch (item.label) {
                    case 'PR-1':
                        state.procedureData[id]["deductibles"] = '0.00';
                        break;
                    case 'PR-2':
                        state.procedureData[id]["co_insurance"] = '0.00';
                        break;
                    case 'PR-3':
                        state.procedureData[id]["copay"] = '0.00';
                        break;
                    default:
                        break;
                }
            } else {
                state.procedureData[id]["claim_status_id"] = null;
                state.procedureData[id]["claim_sub_status_id"] = null;
            }
        },


        /**
         * to add adjustment amount
         * @param {*} state 
         * @param {*} actions 
         */
        addAdjustmentAmount: (state, actions) => {
            let { value, adjustment, id, field } = actions.payload;
            let { procedureData } = current(state);

            let procedureRowToEdit = { ...procedureData[id] };

            let fieldArray = [...procedureRowToEdit[field]];

            let procedureIndex = fieldArray.findIndex((item) => item.id === adjustment.id);

            if (procedureIndex !== -1) {
                fieldArray[procedureIndex] = {
                    ...fieldArray[procedureIndex],
                    amount: value,
                };
            }

            procedureRowToEdit[field] = fieldArray;

            if (
                adjustment.label === 'PR-1' || adjustment.label === 'PR-2' || adjustment.label === 'PR-3'
            ) {
                switch (adjustment.label) {
                    case 'PR-1':
                        procedureRowToEdit["deductibles"] = value;
                        break;
                    case 'PR-2':
                        procedureRowToEdit["co_insurance"] = value;
                        break;
                    case 'PR-3':
                        procedureRowToEdit["copay"] = value;
                        break;
                    default:
                        break;
                }
            }
            state.procedureData[id] = procedureRowToEdit;
        },

        /**
         * adding remark codes to list
         * @param {*} state 
         * @param {*} actions 
         */
        onAddRemarkCodes: (state, actions) => {
            let { value, id } = actions.payload;
            if (value.length > 0) {
                let arrayId = [];
                let arrayCodes = [];
                value.map((item) => {
                    arrayId.push(item.id);
                    arrayCodes.push(item);
                });
                if (value) {
                    state.procedureData[id]['remark_code'] = arrayId;
                } else {
                    state.procedureData[id]['remark_code'] = [];
                }
                state.procedureData[id]['selectedRemarkCodes'] = arrayCodes;
            }
            else {
                state.procedureData[id]['remark_code'] = [];
                state.procedureData[id]['selectedRemarkCodes'] = [];
            }
        },

        /**
         * function to store moved to credit switch value
         * @param {*} state 
         * @param {*} action 
         */
        onMovedToCreditChange: (state, action) => {
            let { id, value } = action.payload;
            state.procedureData[id].moved_to_credit = !value;
            const currentStatus = value;

            const opening_balance = decimalConverter(state.procedureData[id]["opening_balance"]);
            const paid_amount = decimalConverter(state.procedureData[id]["paid_amount"]);
            const totalAdjustment1Amount = decimalConverter(state.procedureData[id].adjustment_code1_data?.reduce((total, item) => total + (Number(item?.amount) || 0), 0));
            state.procedureData[id]['moved_to_credit'] = !currentStatus;
            const calculatedClosingBalance = Number((opening_balance - paid_amount - totalAdjustment1Amount).toFixed(2));
            state.procedureData[id]['closing_balance'] = calculatedClosingBalance
        },
        /**
         * function to close eramodal window
         * @param {*} state 
         */
        closeERAModel: (state) => {
            let {lastOpenedClaimRowItem,isNewClaimAdded}=current(state)
            state.eraReviewModal = false;
            state.procedureData = initialState.procedureData;
            state.procedureError = initialState.procedureError;
            state.isAllProcedureApplied = initialState.isAllProcedureApplied;
            state.resposibility = initialState.resposibility;
            state.originalResponsibility = initialState.originalResponsibility;
            state.duplicateProcedureData = initialState.duplicateProcedureData;
            if(!isNewClaimAdded){
                if(!state.reviewData[lastOpenedClaimRowItem].is_reviewed){
                    state.reviewData[lastOpenedClaimRowItem].checked=false;
                }
            }
        },

        showEditModalWindow: (state, action) => {
            state.showEditERAModal = action.payload;
            if (action.payload == true) {
                state.eraEditModalData = { ...state.eraOriginalData };
                state.eramodalEditFlag = true;
            } else {
                state.eraEditModalData = {}
                state.eramodalEditFlag = false;
            }

        },

        /**
         * redux function to add new claim to existing ERA
         * @param {*} state 
         */
        addNewClaim: (state, actions) => {
            state.addNewModal = actions.payload;
            if (!actions.payload) {
                state.claimDataForEraManualAdd = [];
            }
        },

        /**
         * function is used to redirect to search window on aarow back button click
         * @param {*} state 
         */
        showSearchAction: () => initialState,

        /**
         * to close all modal window
         * @param {} state 
         * @param {*} action 
         */
        handleCloseModalWindow: (state, action) => {
            let { name, value } = action.payload
            if (name !== "columnModalOpen") {
                state[name] = value;
                state.current_procedure_id = "";
            } else {
                state.xlsExportKey = initialState.xlsExportKey;
            }
        },

        /**
         * funciton is used to redirect to preview window on preview back button click
         * @param {*} state 
         */
        showPreviewAction: (state) => {
            state.searchKey = true;
            state.reviewKey = false;
            state.procedureData = initialState.procedureData;
            state.duplicateProcedureData = initialState.duplicateProcedureData;
            state.procedureErro = initialState.procedureError;
            state.claimDataForEraManualAdd = initialState.claimDataForEraManualAdd;
            state.lastOpenedClaimRowItem = initialState.lastOpenedClaimRowItem;
            state.originalResponsibility = initialState.originalResponsibility;
            state.resposibility = initialState.resposibility;
            state.isAllProcedureApplied = initialState.isAllProcedureApplied;
            state.selectedPaymentPK = initialState.selectedPaymentPK;
            state.isReviewAll = initialState.isReviewAll;
        },

        /**
         * modal window handle change function to store in state
         * @param {*} state 
         * @param {*} action 
         */
        onValueChangeEditModalWindow: (state, action) => {
            let { value, name, type } = action.payload;
            if (type == "Date" && value && value instanceof Date && !isNaN(value)) {
                state.eraEditModalData[name] = value ?? ""
            } else {
                state.eraEditModalData[name] = value ?? ""
            }
        },
        /**
         * function to make check box clickable
         * @param {*} state 
         * @param {*} actions 
         */
        onCheckboxClickTable: (state, actions) => {
            let { claim_pk, ele } = actions.payload;
            const item = state.reviewData[ele];
            if (item) {
                item.checked = !item.checked;
                if (item.checked === true) {
                    // Ensure the list exists before pushing
                    if (!state.reviewedClaimList) {
                        state.reviewedClaimList = [];
                    }
                    state.reviewedClaimList.push(claim_pk);
                } else {
                    state.reviewedClaimList = (state.reviewedClaimList ?? []).filter(item => item !== claim_pk);
                }
                state.reviewData[ele] = item;
            }

            const allChecked = Object.values(state.reviewData).every(item => item.checked);
            state.isReviewAll = allChecked;
        },

        /**
         * header check box all click
         * @param {*} state 
         */
        onCheckBoxAllClick: (state) => {
            const { reviewData } = current(state);
            const updated = {};
            for (const key in reviewData) {
                updated[key] = { ...reviewData[key], checked: !state.isReviewAll };
            }
            state.reviewData = updated;
            state.isReviewAll = !state.isReviewAll;
            if (state.isReviewAll) {
                const claimReviewedList = Object.values(reviewData).forEach(item => item.claim_pk);
                state.reviewedClaimList = claimReviewedList;
            } else {
                state.reviewedClaimList = []
            }
        },

        /**
         * filter option select input change
         * @param {*} state 
         * @param {*} actions 
         */
        onFilterOptionChange: (state, actions) => {
            let { value, name } = actions.payload;
            const selectedOption = filter_Options.find(option => option.id === value);
            state.filterOption = {
                ...state.filterOption,
                [name]: value,
                filterlabel: selectedOption.name,
                searchTerm: ""
            }
        },

        /**
         * filter search term catch here
         * @param {*} state 
         * @param {*} actions 
         */
        onSearchTermChange: (state, actions) => {
            let { filterOption, originalReviewData } = current(state);
            let filterValue;
            let filterResult;
            let filterKey = filterOption.selectInputValue;
            let { value, name } = actions.payload;
            state.filterOption = {
                ...state.filterOption,
                [name]: value,
            }

            // To accept only numbers
            const onlyNumberAllowed = ['claim_id', 'patient_id', 'cpt_payment'];
            if (onlyNumberAllowed.includes(filterOption.selectInputValue) && isNaN(value)) { // To accept only numbers
                return;
            }

            if (filterKey !== 'dos') { // handle filter for all parameters except date
                filterValue = value.toString().toLowerCase();
                if (filterValue === '') {
                    state.reviewData = state.originalReviewData;
                    return;
                }
            } else {
                filterValue = DateTime.fromJSDate(value).toFormat('yyyy-MM-dd');
            }

            let data = { ...originalReviewData }
            filterResult = Object.entries(data).filter(([, claim]) => {
                const fieldValue = (claim[filterKey] || '').toString().toLowerCase();
                return (
                    fieldValue.startsWith(filterValue) ||
                    fieldValue.endsWith(filterValue)
                );
            });
            state.reviewData = Object.fromEntries(filterResult);

        },
        /**
         * function to clear filters
         * @param {*} state 
         */
        handleClearFilter: (state) => {
            state.filterOption = initialState.filterOption;
            state.reviewData = state.originalReviewData;
        },

        /**
         * function to open delete confirmation 
         * @param {*} state 
         * @param {*} actions 
         */
        deleteModalOpen: (state, action) => {
            const { open, claim_id = "", claim_pk = "", ele = "" } = action.payload;

            state.deleteModal = {
                open,
                claim_id: open ? claim_id : "",
                claim_pk: open ? claim_pk : "",
                element: open ? ele : ""
            };
        },

        /**
         * making paid by entity to true if the first payment is done
         * @param {*} state 
         * @param {*} actions 
         */
        onAlertClick: (state, actions) => {
            let { value, popValue } = actions.payload;
            let id = state.current_procedure_id;
            if (popValue === 'yes') {
                state.procedureData[id]["moved_to_credit"] = true;
            }
            state.credit_confirmation_modal = value
        },

        /**
         * function to undo the changes
         * @param {*} state 
         * @param {*} actions 
         */
        ResetProcedure: (state, actions) => {
            let { id } = actions.payload;
            state.procedureData[id] = state.duplicateProcedureData[id]
        },

        /**
         * set over ride status
         * @param {*} state 
         */
        setOverRide: (state) => {
            state.saveWithOverRide = true;
        },
        /**
         * xls download popup 
         * @param {*} state 
         * @param {*} actios 
         */
        loadExcelColumnModals: (state, actions) => {
            let { id } = actions.payload
            let data = {
                isFieldsChecked: false,
                selectedPK: id,
                selectedColumns: defaultSelectedColumnsList,
                columnModalOpen: true,
                columnHeader: i18n.t('payments.eraPage.addOptionalColumns'),
            }
            state.xlsExportKey = data;
        },

        /**
         * on xls column select select all click
         * @param {*} state 
         * @param {*} actions 
         */
        onXlsColumnonSelectAllClick: (state, actions) => {
            state.xlsExportKey.isFieldsChecked = !state.xlsExportKey.isFieldsChecked;
            if (actions.payload) {
                let fullFields = [];
                fullFields = fullFields.concat(columnsNameList1);
                fullFields = fullFields.concat(columnsNameList2);
                fullFields = fullFields.concat(columnsNameList3);
                fullFields = fullFields.concat(columnsNameList4);
                fullFields = fullFields.concat(columnsNameList5);
                state.xlsExportKey.selectedColumns = fullFields;
            } else {
                state.xlsExportKey.selectedColumns = [];
            }
        },

        /**
         * 
         * @param {*} e 
         * @param {*} item 
         */
        onSelectOptionalColumn(state, action) {
            const column = action.payload;
            const selected = state.xlsExportKey.selectedColumns;

            const index = selected.indexOf(column);

            if (index >= 0) {
                selected.splice(index, 1); // Remove if already selected
            } else {
                selected.push(column); // Add if not selected
            }

            state.xlsExportKey.selectedColumns = selected;

        }
    },
    extraReducers: (builder) => {
        /**
         * getERApayerlist pending state initial api call
         */
        builder.addCase(getERApayerList.pending, (state) => {
            state.loader = true;
        })

        /**
         * getERApayerlist fullfilled state api call success 
         */
        builder.addCase(getERApayerList.fulfilled, (state, action) => {
            state.list.eraPayerList = action.payload;
            state.loader = false;
        })


        /**
         * getERApayerlist fullfilled state api call failed 
         */
        builder.addCase(getERApayerList.rejected, (state) => {
            state.loader = false;
        })

        /**
         * getERApayerlist pending state initial api call
         */
        builder.addCase(getERAlist.pending, (state) => {
            state.loader = true;
        })

        /**
         * getERApayerlist fullfilled state api call success 
         */
        builder.addCase(getERAlist.fulfilled, (state, action) => {
            let { tableData, page, calledFrom } = action.payload;
            state.selectedEraList = [];
            state.selectAll = false;
            if (tableData?.results?.length) {
                let totalPage = Math.ceil(tableData.count / tableData.page_size)
                state.pagination.totalPage = totalPage;
            } else {
                state.pagination.totalPage = 1;
            }

            if (calledFrom == 'search') {
                state.pagination.activePage = page;
                state.pagination.startIndex = 0;
                state.pagination.endIndex = PAGING_END_INDEX;
            }

            state.eraTableData = tableData?.results ?? [];
            state.pageSelector.totalCount = tableData?.count;
            state.searchKey = true;
            state.calledFrom = calledFrom;
            state.loader = false;
        })


        /**
         * getERApayerlist fullfilled state api call failed 
         */
        builder.addCase(getERAlist.rejected, (state) => {
            state.loader = false;
        })


        /**
        * getERASummuryData pending state initial api call
        */
        builder.addCase(getERASummuryData.pending, (state) => {
            state.loader = true;
        })

        /**
         * getERASummuryData fullfilled state api call success 
         */
        builder.addCase(getERASummuryData.fulfilled, (state, action) => {
            let { eraData, header_result, summaryData, id, isApplied } = action.payload;
            state.lastOpenedEraRowItem = id;
            if (isApplied === 2) {
                state.isApplied = true;
            }
            else {
                state.isApplied = false;
            }

            state.eraAppliedStatus = isApplied;
            state.loader = false;
            state.eraOriginalData = header_result;
            state.reviewKey = true;
            let eraAdjustment = eraData != {} ? eraData : [];
            const eraAdjustmentResult = eraDataFormatter(eraAdjustment);
            const { paymentVariable, insuranceVarible, paymentAdjustmentAmount } = headerResultFormatter(header_result);
            const summaryDataResult = summaryResultFromatter(summaryData);
            state.list.payAdjTypeArr = summaryData.era_adjustment_type ? summaryData.era_adjustment_type : [];
            let tempPayAdjType = []
            if (eraAdjustmentResult?.length > 0 && summaryData?.era_adjustment_type?.length > 0) {
                eraAdjustmentResult.forEach(item => {
                    if (summaryData.era_adjustment_type.includes(item.name)) {
                        tempPayAdjType.push(item.id)
                    }
                });
            }
            state.paymentAdjustmentAmount = paymentAdjustmentAmount;
            state.editEraVariables = paymentVariable;
            state.insurancePaymentVariables = insuranceVarible;
            state.list.paymentAdjustmentType = tempPayAdjType;
            state.list.multiPayAdjType = eraAdjustmentResult;
            state.reviewData = summaryDataResult;
            state.originalReviewData = summaryDataResult;

            const allChecked = Object.values(summaryDataResult).every(item => item.is_reviewed);
            state.isReviewAll = allChecked;
        })


        /**
         * getERASummuryData fullfilled state api call failed 
         */
        builder.addCase(getERASummuryData.rejected, (state,action) => {
            state.loader = false;
            state.notifyMessage = action.payload;
            state.showNotification = true;
            state.statusTag = "error"
        })

        /**
         * reviewClaimData fullfilled state api call pending 
         */
        builder.addCase(reviewClaimData.pending, (state) => {
            state.loader = true;
        })


        /**
         * reviewClaimData fullfilled state api call success 
         */
        builder.addCase(reviewClaimData.fulfilled, (state, action) => {
            state.loader = false;
            let { result, is_applied, claim_pk, newClaimAdded, ele } = action.payload;
            state.isNewClaimAdded = newClaimAdded;
            state.selectedPaymentPK = claim_pk;
            if (is_applied) {
                state.isAllProcedureApplied = true;
            } else {
                state.isAllProcedureApplied = false;
            }
            if (result && result.length > 0) {
                let { jsonObject, originalResponsibility } = structureProcedureData(result, claim_pk);
                state.resposibility = result[0]?.responsibilites || RESPONSIBILITY_TYPES
                state.originalResponsibility = originalResponsibility;
                state.procedureData = jsonObject;
                state.duplicateProcedureData = jsonObject;
                state.eraReviewModal = true;
                state.lastOpenedClaimRowItem = !newClaimAdded ? ele : "";
                if(!newClaimAdded){
                state.reviewData[ele].checked = true;
                }
            }

            /**if new claim closing and clearing data from new claim adding modal */
            if (newClaimAdded) {
                state.list.claimsListForModalDropdown = initialState.list.claimsListForModalDropdown;
                state.claimDataForEraManualAdd = initialState.claimDataForEraManualAdd;
                state.addNewModal = false;
            }
        })


        /**
         * reviewClaimData fullfilled state api call failed 
         */
        builder.addCase(reviewClaimData.rejected, (state) => {
            state.loader = false;
        })

        /**
         * get claimstatus sub ststuas fullfilled state api call success 
         */
        builder.addCase(getClaimStatusSubStatus.fulfilled, (state, action) => {
            let { claimStatusList,
                claimSubStatusList } = action.payload
            state.list.claimStatusList = claimStatusList;
            state.list.claimSubStatusList = claimSubStatusList;
        })


        /**
        * get adjustment api call success 
        */
        builder.addCase(getAdjustmentCode.fulfilled, (state, action) => {
            let { result, name } = action.payload
            state.list[name] = result;
        })


        /**
        * get getClaimListForDropDown api call pending 
        */
        builder.addCase(getClaimListForDropDown.pending, (state) => {
            state.isAsyncTypeSearching = true;
        })

        /**
        * get getClaimListForDropDown api call success 
        */
        builder.addCase(getClaimListForDropDown.fulfilled, (state, action) => {
            let { result, name } = action.payload
            state.list[name] = result;
            state.isAsyncTypeSearching = false;
        })


        /**
        * get getClaimListForDropDown api call rejected or failed 
        */
        builder.addCase(getClaimListForDropDown.rejected, (state) => {
            state.isAsyncTypeSearching = false;
            state.list.claimsListForModalDropdown = [];
        })



        /**
        * get getClaimDetailsOnSelect api call pending 
        */
        builder.addCase(getClaimDetailsOnSelect.pending, (state) => {
            state.loader = true;
        })

        /**
        * get getClaimDetailsOnSelect api call success 
        */
        builder.addCase(getClaimDetailsOnSelect.fulfilled, (state, action) => {
            let data = {
                claim_id: action.payload[0].id,
                custom_claim_id: action.payload[0].custom_claim_id,
                patient_name: action.payload[0].patient_name,
                dos_from: YMD_TO_MDY(action.payload[0].dos_from),
                charges: action.payload[0].charges,
                balance: action.payload[0].balance,
                payer_types: action.payload[0].payer_types.type,
                responsible_payer: action.payload[0].responsible_payer
            }
            state.claimDataForEraManualAdd = data;
            state.loader = false;
        })


        /**
        * get getClaimDetailsOnSelect api call rejected or failed 
        */
        builder.addCase(getClaimDetailsOnSelect.rejected, (state, action) => {
            state.loader = false;
            if (action.payload) {
                state.notifyMessage = action.payload;
                state.showNotification = true;
                state.statusTag = action.payload.status
            }
        })

        /**
        * get added claim Details manually api call pending 
        */
        builder.addCase(addSelectedClaimToERAManually.pending, (state) => {
            state.loader = true;
        })

        /**
        * get added claim Details manually api call pending 
        */
        builder.addCase(addSelectedClaimToERAManually.fulfilled, (state) => {
            state.loader = false;
        })

        /**
        * get added claim Details manually api call pending 
        */
        builder.addCase(addSelectedClaimToERAManually.rejected, (state, action) => {
            state.loader = false;
            if (action.payload) {
                state.notifyMessage = action.payload;
                state.showNotification = true;
                state.statusTag = action.payload.status
            }
        })

        /**
        * SaveEraDetails api call pending 
        */
        builder.addCase(SaveEraDetails.pending, (state) => {
            state.loader = true;
        })

        /**
        * SaveEraDetails api call pending 
        */
        builder.addCase(SaveEraDetails.fulfilled, (state, action) => {
            state.loader = false;
            state.eramodalEditFlag = false;
            state.showEditERAModal = false;
            state.eraEditModalData = {};
            state.eraOriginalData = {
                ...state.eraOriginalData,
                ...action.payload.data
            };
            const savedStatus = action.payload.data?.applied_status;
            if (savedStatus != null && savedStatus !== '') {
                state.eraAppliedStatus = savedStatus;
            }
        })

        /**
        * SaveEraDetails api call pending 
        */
        builder.addCase(SaveEraDetails.rejected, (state, action) => {
            state.loader = false;
            if (action.payload) {
                state.notifyMessage = action.payload;
                state.showNotification = true;
                state.statusTag = "error"
            }
        })

        /**
        * MarkAsReviewed api call pending 
        */
        builder.addCase(MarkAsReviewed.pending, (state) => {
            state.loader = true;
        })

        /**
        * MarkAsReviewed api call pending 
        */
        builder.addCase(MarkAsReviewed.fulfilled, (state, actions) => {
            state.loader = false;
            const summaryDataResult = summaryResultFromatter(actions.payload);
            state.reviewData = summaryDataResult;
        })

        /**
        * SaveEraDetails api call pending 
        */
        builder.addCase(MarkAsReviewed.rejected, (state, action) => {
            state.loader = false;
            if (action.payload) {
                state.notifyMessage = action.payload;
                state.showNotification = true;
                state.statusTag = "error"
            }
        })


        /**
        * MarkAsReviewedonSave api call pending 
        */
        builder.addCase(MarkAsReviewedOnSave.pending, (state) => {
            state.loader = true;
        })

        /**
        * MarkAsReviewed api call pending 
        */
        builder.addCase(MarkAsReviewedOnSave.fulfilled, (state, actions) => {
            state.loader = false;
            state.reviewData[actions.payload].is_reviewed=true;
            state.reviewData[actions.payload].checked=true;
            state.originalReviewData[actions.payload].is_reviewed=true;
            state.originalReviewData[actions.payload].checked=true;
        })

        /**
        * SaveEraDetails api call pending 
        */
        builder.addCase(MarkAsReviewedOnSave.rejected, (state, action) => {
            state.loader = false;
            if (action.payload) {
                state.notifyMessage = action.payload;
                state.showNotification = true;
                state.statusTag = "error"
            }
        })

        /**
        * onDeleteClaimAction api call pending 
        */
        builder.addCase(onDeleteClaimAction.pending, (state) => {
            state.loader = true;
        })

        /**
        * onDeleteClaimAction api call pending 
        */
        builder.addCase(onDeleteClaimAction.fulfilled, (state, actions) => {
            state.loader = false;
            let { id } = actions.payload;
            state.deleteModal = initialState.deleteModal;
            delete state.reviewData[id];
            delete state.originalReviewData[id];
            state.notifyMessage = DELETE_SUCCESS;
            state.showNotification = true;
            state.statusTag = "success"
        })

        /**
        * onDeleteClaimAction api call pending 
        */
        builder.addCase(onDeleteClaimAction.rejected, (state, action) => {
            state.loader = false;
            if (action.payload) {
                state.notifyMessage = action.payload;
                state.showNotification = true;
                state.statusTag = "error"
            }
        })

        /**
        * eraProcedureDataSave api call pending 
        */
        builder.addCase(eraProcedureDataSave.pending, (state) => {
            state.loader = true;
        })

        /**
        * eraProcedureDataSave api call pending 
        */
        builder.addCase(eraProcedureDataSave.fulfilled, (state, actions) => {
            state.loader = false;
            let { result_data, is_new_claim_id, over_ride_status } = actions.payload;
            let { lastOpenedClaimRowItem } = current(state);
            if (over_ride_status) {
                state.procedureError = initialState.procedureError;
                state.openMuiDialogueForProcedure = false;
            }

            if (is_new_claim_id) {
                /**storing a new entry to the check */
                const new_entry = summaryResultFromatter(result_data);
                Object.assign(state.reviewData, new_entry);
                Object.assign(state.originalReviewData, new_entry);
                state.procedureData = initialState.procedureData;
                state.duplicateProcedureData = initialState.duplicateProcedureData;
                state.eraReviewModal = false;
                state.lastOpenedClaimRowItem = result_data.length > 0 ? result_data[0].claim_id : "";
            } else {
                /**storing new data to the existing entry */
                const new_entry = summaryResultFromatter(result_data);
                state.reviewData[lastOpenedClaimRowItem] = new_entry[lastOpenedClaimRowItem];
                state.procedureData = initialState.procedureData;
                state.duplicateProcedureData = initialState.duplicateProcedureData;
                state.eraReviewModal = false;
            }
        })

        /**
        * eraProcedureDataSave api call pending 
        */
        builder.addCase(eraProcedureDataSave.rejected, (state, action) => {
            let { message, type, close } = action.payload
            state.loader = false;
            if (type == "msg") {
                state.notifyMessage = message;
                state.showNotification = true;
                state.statusTag = "error"
            }

            if (type == "info") {
                state.notifyMessage = message;
                state.showNotification = true;
                state.statusTag = "info"
            }

            if (type == "waring") {
                state.openMuiDialogueForProcedure = true;
            }

            if (type == "confirmation") {
                state.isManuallyAddClaimCloseConfirm = true;
            }

            if (close) {
                state.eraReviewModal = false;
            }
        })

        /**
        * onApplyPayment api call pending 
        */
        builder.addCase(onApplyPayment.pending, (state) => {
            state.loader = true;
        })

        /**
        * onApplyPayment api call pending 
        */
        builder.addCase(onApplyPayment.fulfilled, (state, actions) => {
            state.loader = false;
            state.notifyMessage = i18n.t("successMessages.ERA_post_success");
            state.showNotification = true;
            state.statusTag = "success"
            if (actions.payload?.is_applied == 2) {
                state.isApplied = true;
                state.eraAppliedStatus = actions.payload?.is_applied
            } else {
                state.isApplied = false;
                state.eraAppliedStatus = actions.payload?.is_applied
            }

            state.searchKey = true;
            state.reviewKey = false;
            state.reviewData = {};
            state.procedureData = {};
            state.duplicateProcedureData = {};
            state.originalReviewData = {};
            state.resposibility = [];
            state.originalResponsibility = [];
            state.insurancePaymentVariables = initialState.insurancePaymentVariables;
            state.editEraVariables = initialState.editEraVariables;
            state.isapplied_success = true;
        })

        /**
        * onApplyPayment api call pending 
        */
        builder.addCase(onApplyPayment.rejected, (state, action) => {
            state.loader = false;
            state.notifyMessage = action.payload;
            state.showNotification = true;
            state.statusTag = "error"
        })


        /**
        * all era list export api call pending 
        */
        builder.addCase(onAllERAListExport.fulfilled, (state, actions) => {
            state.loader = false;
            let { header, data } = actions.payload;
            fileDownload(data, header['content-disposition']);
        })

        /**
        * all era list export  api call pending 
        */
        builder.addCase(onAllERAListExport.rejected, (state, action) => {
            state.loader = false;
            if (action.payload) {
                state.notifyMessage = action.payload;
                state.showNotification = true;
                state.statusTag = "error"
            }
        })

        /**
        * onDeleteClaimAction api call pending 
        */
        builder.addCase(onAllERAListExport.pending, (state) => {
            state.loader = true;
        })

        /**
        * all era list export api call pending 
        */
        builder.addCase(onExportFiles.fulfilled, (state, { payload }) => {
            state.loader = false;
            const { header, data, type } = payload;

            if (type === "era_file" && data?.url) {
                const link = document.createElement("a");
                link.href = data.url;
                link.download = "ERA.pdf";
                link.target = "_blank";
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                return;
            }

            if (data && header?.["content-disposition"]) {
                fileDownload(data, header["content-disposition"]);

                if (type == "xls") {
                    state.xlsExportKey = initialState.xlsExportKey;
                }
            }
        });

        /**
        * all era list export  api call pending 
        */
        builder.addCase(onExportFiles.rejected, (state, action) => {
            state.loader = false;
            if (action.payload) {
                state.notifyMessage = action.payload;
                state.showNotification = true;
                state.statusTag = "error"
            }
        })

        /**
        * onDeleteClaimAction api call pending 
        */
        builder.addCase(onExportFiles.pending, (state) => {
            state.loader = true;
        })
    }

});

export const { onHandleChangeVariables, onHandleDateChange, onResetERASearchVariable, onPageLimitChange, onFilterOptionChange,
    resetNotifyWindow, showNotifyWindow, onPagePreviousChange, onPageNextChange, onPageUpChange, onAddRemarkCodes, onAlertClick,
    onHandleApply, onBlurApplyValue, handleAdjustmentCodeChangeAction, removeAdjustmentCode, addAdjustmentAmount, deleteModalOpen,
    onMovedToCreditChange, closeERAModel, showSearchAction, showPreviewAction, addNewClaim, closeEditDetailsModal, handleClearFilter,
    showEditModalWindow, onValueChangeEditModalWindow, onCheckboxClickTable, onCheckBoxAllClick, handleCloseModalWindow, onSearchTermChange,
    ResetProcedure, setOverRide, onGridCheckBoxClickEraList, loadExcelColumnModals, onXlsColumnonSelectAllClick, onSelectOptionalColumn
} = eraSlice.actions

export default eraSlice.reducer;